/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

export type ListChallengeBucketsSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

/**
 * Filter by outcome.
 */
export const Outcome = {
  Allow: "allow",
  Deny: "deny",
} as const;
/**
 * Filter by outcome.
 */
export type Outcome = ClosedEnum<typeof Outcome>;

export type ListChallengeBucketsRequest = {
  /**
   * Filter by outcome.
   */
  outcome?: Outcome | undefined;
  /**
   * Filter by principal URN.
   */
  principalUrn?: string | undefined;
  /**
   * Filter by scope.
   */
  scope?: string | undefined;
  /**
   * Filter to a specific project.
   */
  projectId?: string | undefined;
  /**
   * Filter by resolution state. True = only resolved, false = only unresolved.
   */
  resolved?: boolean | undefined;
  /**
   * Maximum number of buckets to return.
   */
  limit?: number | undefined;
  /**
   * Number of buckets to skip.
   */
  offset?: number | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListChallengeBucketsSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListChallengeBucketsSecurity$outboundSchema: z.ZodMiniType<
  ListChallengeBucketsSecurity$Outbound,
  ListChallengeBucketsSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listChallengeBucketsSecurityToJSON(
  listChallengeBucketsSecurity: ListChallengeBucketsSecurity,
): string {
  return JSON.stringify(
    ListChallengeBucketsSecurity$outboundSchema.parse(
      listChallengeBucketsSecurity,
    ),
  );
}

/** @internal */
export const Outcome$outboundSchema: z.ZodMiniEnum<typeof Outcome> = z.enum(
  Outcome,
);

/** @internal */
export type ListChallengeBucketsRequest$Outbound = {
  outcome?: string | undefined;
  principal_urn?: string | undefined;
  scope?: string | undefined;
  project_id?: string | undefined;
  resolved?: boolean | undefined;
  limit: number;
  offset: number;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListChallengeBucketsRequest$outboundSchema: z.ZodMiniType<
  ListChallengeBucketsRequest$Outbound,
  ListChallengeBucketsRequest
> = z.pipe(
  z.object({
    outcome: z.optional(Outcome$outboundSchema),
    principalUrn: z.optional(z.string()),
    scope: z.optional(z.string()),
    projectId: z.optional(z.string()),
    resolved: z.optional(z.boolean()),
    limit: z._default(z.int(), 50),
    offset: z._default(z.int(), 0),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      principalUrn: "principal_urn",
      projectId: "project_id",
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
    });
  }),
);

export function listChallengeBucketsRequestToJSON(
  listChallengeBucketsRequest: ListChallengeBucketsRequest,
): string {
  return JSON.stringify(
    ListChallengeBucketsRequest$outboundSchema.parse(
      listChallengeBucketsRequest,
    ),
  );
}
